<template>
  <div class="py-3 h-100">
    <div class="d-flex justify-content-between align-items-center">
      <p class="my-4">Bill of Quantities</p>
      <div>
        <button class="btn btn-success" v-if="filePreview" @click="submit()">
          Submit BQ
        </button>
        <button
          class="btn btn-danger ms-3"
          v-if="filePreview"
          @click="cancelAttachment()"
        >
          Clear file
        </button>
      </div>
    </div>

    <!-- <iframe
      v-if="bq"
      :src="Helper.formatMediaUrl(bq)"
      class="w-100 h-100"
      frameborder="0"
    /> -->

    <div class="image-grid image-grid-placeholder border-0 bg-dark" v-if="bq">
      <button
        class="btn btn-dark h-100 w-100 lh-sm"
        @click="currentPdf = Helper.formatMediaUrl(bq)"
      >
        <i class="fa-solid fa-file-pdf fa-2x mb-2 d-block" />
        Click to view
      </button>
    </div>

    <iframe
      v-else-if="filePreview"
      :src="filePreview"
      class="w-100 h-100"
      frameborder="0"
    />

    <div v-else class="bg-semi-transparent text-warning p-4 text-center">
      <div>
        <i class="fa-solid fa-exclamation-triangle me-2" />
        Bill of Quantity not available
      </div>

      <div class="pt-4">
        <div class="image-grid image-grid-placeholder">
          <button class="btn h-100 w-100 fw-bold lh-sm" @click="addFile()">
            <i class="fa-solid fa-file-upload mb-3 d-block" />
            Upload PDF
          </button>
        </div>
      </div>
    </div>

    <pdf-viewer
      :url="currentPdf"
      v-if="currentPdf"
      @close="currentPdf = null"
    />
  </div>
</template>

<script>
import Swal from "sweetalert2";
import PdfViewer from "@/components/PdfViewer";

export default {
  props: ["componentId", "status", "pavementId"],
  components: { PdfViewer },
  data() {
    return {
      bq: null,
      invalidFields: [],
      currentPdf: null,
      fileInput: null,
      filePreview: null,
    };
  },
  methods: {
    submit() {
      Swal.fire({
        icon: "question",
        title: "<h5 class='fw-bold'>Submit Bill of Quantity?</h5>",
        html: "<p class='mb-0'>This action is not reversible.<br />Data cannot be changed after it is submitted.</p>",
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonText: "Confirm",
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.Helper.toggleLoadingSpinner(true);

          await this.uploadFileInput();

          await this.getBq();

          this.filePreview = null;

          this.fileInput = null;

          this.triggerAlert(
            "success",
            "Bill of Quantity uploaded",
            "componentIsCompleted"
          );
        }
      });
    },
    async uploadFileInput() {
      return new Promise(async (resolve, reject) => {
        let fileModels = {
          ref: "pavement-case",
          refId: this.pavementId,
          field: "bq",
          files: "",
        };

        const formData = new FormData();

        Object.keys(fileModels).forEach((key) => {
          if (key != "files") {
            formData.append(key, fileModels[key]);
          } else {
            formData.append("files", this.fileInput, this.fileInput.name);
          }
        });

        const [call, error] = await this.Helper.handlePromise(
          this.API.postForm("upload", formData)
        );

        if (error) {
          return reject(error);
        } else {
          return resolve("OK");
        }
      });
    },
    cancelAttachment() {
      URL.revokeObjectURL(this.filePreview);

      this.fileInput = null;

      this.filePreview = null;

      this.Helper.removeToast("BQ PDF removed");
    },
    addFile() {
      const input = document.createElement("input");

      input.type = "file";

      input.multiple = false;

      input.accept = "application/pdf";

      input.onchange = this.fileChanged;

      input.click();
    },
    fileChanged(e) {
      const file = e.target.files[0];
      if (!file) return;

      this.fileInput = file;

      this.filePreview = URL.createObjectURL(file);

      this.Helper.successToast("BQ PDF added");
    },
    triggerAlert(icon, text, callback, callbackData) {
      Swal.fire({
        icon: icon,
        title: `<h5>${text}</h5>`,
      }).then(() => {
        if (callback) {
          this.$emit(callback, callbackData);
        }
      });
    },
    async getBq() {
      if (this.pavementId) {
        this.Helper.toggleLoadingSpinner(true);

        const [call, error] = await this.Helper.handlePromise(
          this.API.get(`pavement-cases/${this.pavementId}`)
        );

        if (error) {
          this.triggerAlert("error", "Error getting BQ data");
        } else {
          this.bq = call.data.bq;
        }

        this.Helper.toggleLoadingSpinner(false);
      }
    },
  },
  async mounted() {
    await this.getBq();
  },
};
</script>